import * as Type from './actionsTypes';

const loadJornada = id => ({ type: Type.FETCH_JORNADA, id });

const cleanSelectedJornada = () => ({ type: Type.CLEAR_SELECTED_JORNADA });

const saveJornada = (data, callback) => ({ type: Type.SAVE_JORNADA, data, callback });

const exportJornadas = (filtro, callback) => ({ type: Type.EXPORT_JORNADAS, filtro, callback });

const deleteJornada = (id, callback) => ({ type: Type.JORNADA_DELETE, id, callback });

const downloadJornadas = (filter, callback) => ({ type: Type.JORNADA_DOWNLOAD, filter, callback });

const validateJornada = (id, data, callback) => ({
  type: Type.JORNADA_VALIDATE,
  id,
  data,
  callback,
});

export {
  loadJornada,
  cleanSelectedJornada,
  saveJornada,
  exportJornadas,
  deleteJornada,
  downloadJornadas,
  validateJornada,
};
